import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class TextHTML extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler,isEvent} = this.props;
    if(isEvent===true){
      changeHandler(e.target.value,e);
    }else{
      changeHandler(e.target.value);
    }
  } 

  render() {
    const {value} = this.props;
    let bb = <span dangerouslySetInnerHTML={{ __html: value }}></span>
    let attr = setAndGetAttributes(this.props);    
    return (
      <Wrp>
        <textarea 
          contenteditable="true"
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={(value!==null)?value:''}
        >{value}</textarea>        
      </Wrp>        
    );
  }
}

TextHTML.defaultProps = {
  isMandatory:false,
  className: 'form-control',
  isEvent:false
}

export default TextHTML;